/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for update a week model
 * @export
 * @interface WeekModelRequest
 */
export interface WeekModelRequest {
    /**
     * Unique identifier of the day model
     * @type {string}
     * @memberof WeekModelRequest
     */
    dayModelId?: string;
}

/**
 * Check if a given object implements the WeekModelRequest interface.
 */
export function instanceOfWeekModelRequest(value: object): value is WeekModelRequest {
    return true;
}

export function WeekModelRequestFromJSON(json: any): WeekModelRequest {
    return WeekModelRequestFromJSONTyped(json, false);
}

export function WeekModelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeekModelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dayModelId': json['dayModelId'] == null ? undefined : json['dayModelId'],
    };
}

export function WeekModelRequestToJSON(json: any): WeekModelRequest {
    return WeekModelRequestToJSONTyped(json, false);
}

export function WeekModelRequestToJSONTyped(value?: WeekModelRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayModelId': value['dayModelId'],
    };
}

